import { render, staticRenderFns } from "./EnableDisableVideo.vue?vue&type=template&id=1c2f28b3&scoped=true"
import script from "./EnableDisableVideo.vue?vue&type=script&lang=js"
export * from "./EnableDisableVideo.vue?vue&type=script&lang=js"
import style0 from "./EnableDisableVideo.vue?vue&type=style&index=0&id=1c2f28b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f28b3",
  null
  
)

export default component.exports